import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setLoadingAnalysesInStoreAction } from '../../redux/slices/loadingAnalyses';
import {
  IWorkspaceRowFieldsFragment,
  IWsAnalysisInput,
} from '../apollo/graphqlSchema';
import { persistChartState } from '../../redux/utils/chartPersistAndRestore';
import { IAnalysisState } from '../../redux/slices/analyses';
import { assertCondition } from '../types';

export const useLoadWorkspaceAnalyses = () => {
  const dispatch = useDispatch();

  return useCallback(
    (rows: IWorkspaceRowFieldsFragment[]) => {
      dispatch(
        setLoadingAnalysesInStoreAction({
          analysisIds: rows.reduce<string[]>((accumulator, { analyses }) => {
            if (!analyses?.length) {
              return accumulator;
            }

            analyses.forEach((analysis) => {
              accumulator.push(analysis.id);
            });

            return accumulator;
          }, []),
          refresh: false,
        }),
      );
    },
    [dispatch],
  );
};

interface IGenerateWsAnalysisInput {
  analysisId: string;
  display: string;
  description: string;
  currentAnalysis: IAnalysisState;
}

/* Before mutation, each workspace row should be parsed to WsAnalysisInput */
export const generateWsAnalysisInput = ({
  analysisId,
  display,
  description,
  currentAnalysis,
}: IGenerateWsAnalysisInput): IWsAnalysisInput => {
  assertCondition(currentAnalysis.metadata);
  return {
    analysisId,
    display,
    description,
    // TODO: check if aliases should also be exposed
    pref: {
      chartPref: persistChartState({
        queryType: currentAnalysis.metadata.queryType,
        chartSettings: currentAnalysis.settings.chartSettings,
        activeIncidentTypes:
          currentAnalysis.settings.chartSettings.activeIncidentTypes,
      }),
      aliases: null,
    },
  };
};
